<div class="card hover-show w-100 overflow-auto">
    <div class="position-absolute start-0" style="top: 2.5rem">
        <app-energy-label [label]="bestLocationEnergyLabel(location)"></app-energy-label>
    </div>
    <div class="card-body">
        <button type="button"
                class="btn position-absolute top-0 end-0 to-show" role="button" style="right: 24px !important;"
                aria-expanded="false" (click)="openLocationGraph()">
            <i class="bi bi-bar-chart-line"></i>
        </button>
        <app-confirmation-toggle *ngIf="appContext.isManagerForEntity(entity)" (confirmed)="deleteLocation()">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Remove location</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                </div>
                <div class="modal-body mt-0 pb-2">
                    <p *ngIf="hasActiveMeters(entity.location)" class="text-danger">
                        This location has active meters. Deleting it will also remove all associated meters and meter data.
                    </p>
                    <p>Are you sure you want to remove this location?</p>
                </div>
                <div class="modal-footer justify-content-between">
                    <a type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                    <button type="button" class="btn btn-primary" (click)="deleteLocation()" data-bs-dismiss="modal">
                        Remove location
                    </button>
                </div>
            </div>

            <button type="button" class="btn position-absolute top-0 start-0 to-show"
                    role="button" aria-expanded="false">
                <i class="bi bi-trash"></i>
            </button>
        </app-confirmation-toggle>
        <button *ngIf="appContext.isManagerForEntity(entity)" type="button" class="btn position-absolute top-0 start-0 ms-2 to-show" role="button"
                style="left: 24px !important;" aria-expanded="false" (click)="openMoveLocationModal(entity)"
                data-bs-toggle="tooltip" data-bs-placement="top" title="Move location to another organisation">
            <i class="bi bi-arrow-left-right"></i>
        </button>
        <button *ngIf="appContext.isManagerForEntity(entity)" type="button" class="btn position-absolute top-0 end-0 to-show" role="button"
                aria-expanded="false" (click)="openLocationDetails()">
            <i class="bi bi-pencil"></i>
        </button>
        <div class="text-center mb-3 notranslate">
            <h4 class="card-title">{{location.info.address.street}} {{location.info.address.number}} {{location.info.address.addition}}</h4>
            <h4 class="card-title">{{location.info.address.zipCode}} {{location.info.address.city}}</h4>
            <h5 class="text-muted">{{location.info.name}}</h5>
            <span *ngIf="location.info.allElectric" class="badge bg-success">All-electric</span>
        </div>
        <hr class="card-divider mb-0">
        <div class="list-group-flush mb-n3 list-group">
            <div *ngFor="let connection of sortedConnectionsForLocation(); trackBy: trackByForConnection"
                 class="list-group-item py-3"
                 [ngClass]="{'text-muted opacity-50': !isActive(connection)}"
                 [style]="appContext.isManagerForEntity(connection) ? 'cursor: pointer;' : ''"
                 (click)="appContext.isManagerForEntity(connection) ? openConnectionDetails(connection) : null">
                <div class="row hover-underline">
                    <div class="col-auto">
                        <small>
                            <app-connection-image [connectionType]="connection.connection.info.connectionType"></app-connection-image>
                        </small>
                    </div>
                    <div class="col notranslate"><small>{{ connection.connection.info.code }}</small></div>
                    <div class="col-auto notranslate">
                        <span  *ngIf="!isActive(connection)" class="badge bg-danger rounded-pill me-2">Inactive</span>
                        <small>{{ connection.connection.info.operator?.name }}</small>
                    </div>
                </div>
            </div>
            <div *ngIf="appContext.isAdminOrIntermediary()" class="list-group-item py-3 pointer hover-underline" (click)="openConnectionDetails(null)">
                <div class="row">
                    <div class="col-auto">
                        <i class="bi me-2 bi-plus-circle"></i>
                    </div>
                    <div class="col text-truncate"><small>Add new connection</small></div>
                </div>
            </div>
        </div>
    </div>
</div>
